<ng-template #template>
  <div #wrapper [class]="'pr-modal-wrapper ' + clazz">
    <div class="pr-modal-backdrop" (click)="close()"></div>
    <div [class]="'pr-modal ' + display">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
